// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isPristine } from 'redux-form'
import { reInitializeForm } from '../helpers'
import Wrapper from './Wrapper'
import Toggle from './Toggle'

class AdvancedSearchWrapper extends React.Component {
  static propTypes = {
    AdvancedSearch: func.isRequired,
    change: func.isRequired,
    customImportHandler: func,
    hasResults: bool,
    formIsPristine: bool.isRequired,
    highlightRows: bool,
    highlightedRows: array,
    idRoot: string.isRequired,
    reInitializeForm: func.isRequired,
    showContents: bool.isRequired,
    staticLabel: string,
    sourceForm: string.isRequired,
  }

  // this is used as the single options object for the animation toggler.
  state = {
    value: 'show',
    label: '',
  }

  componentWillMount () {
    const {
      staticLabel,
      showContents,
    } = this.props

    let label

    if (staticLabel) {
      label = staticLabel
    } else if (showContents) {
      label = 'Hide Search'
    } else {
      label = 'Show Search'
    }

    this.setState(() => ({ label }))
  }

  componentWillReceiveProps (np) {
    const {
      showContents,
      staticLabel,
    } = this.props
    if (!staticLabel && np.showContents !== showContents) {
      const label = `${showContents ? 'Show' : 'Hide'} Search`
      this.setState(() => ({ label }))
    }
  }

  handleLabelChange = (e, c) => {
    c(e) // bubbles the change event to redux-form.

    const {
      formIsPristine,
      reInitializeForm,
      sourceForm,
    } = this.props

    // don't treat the toggling of the wrapper as a form change if
    // the form was pristine. this is to support pagination
    // because the pagination component only shows if the component is pristine
    // and we want the user to be able to toggle this without toggling pagination
    if (formIsPristine) {
      reInitializeForm(sourceForm)
    }
  }

  render () {
    const {
      AdvancedSearch,
      change,
      customImportHandler,
      hasResults,
      highlightRows,
      highlightedRows,
      idRoot,
      showContents,
      sourceForm,
    } = this.props

    return (
      <>
        <Toggle
          onChangeCustom={this.handleLabelChange}
          idRoot={idRoot}
          options={[this.state]} />
        <Wrapper
          AdvancedSearch={AdvancedSearch}
          change={change}
          customImportHandler={customImportHandler}
          hasResults={hasResults}
          highlightRows={highlightRows}
          highlightedRows={highlightedRows}
          idRoot={idRoot}
          showContents={showContents}
          sourceForm={sourceForm} />
      </>
    )
  }
}

const mapStateToProps = ({ form }, { sourceForm }) => ({
  showContents: !!form[sourceForm].values.advancedSearch.length,
  formIsPristine: isPristine(sourceForm)({ form }),
})

const mapDispatchToProps = (dispatch, props) => (
  bindActionCreators({
    reInitializeForm,
  }, dispatch)
)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdvancedSearchWrapper)
